module.exports = __webpack_public_path__ + "static/gianfranco-imperato-3ec56648adc62c4474c5df30a82530fc.jpg";